// Any custom scripting for direct downlaods
(function($){
	// Direct file downloads
	$(document).on('click', 'a.direct-download', function(e) {
		e.preventDefault();

		let anchor = document.createElement('a');
		anchor.href = this.href;
		anchor.target = '_blank';
		anchor.download = '';
		anchor.click();
	});
})(jQuery);
